import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { firstValueFrom } from "rxjs";

import { OrderModel } from "../models/order.model";
import { DataService } from "../services/data/data.service";
import { MathService } from "../services/math/math.service";
import { OrderService } from "../services/order/order.service";
import { PaymentService } from "../services/payment/payment.service";
import { UtilsService } from "../services/utils/utils.service";

@Injectable({
  providedIn: "root"
})
export class OrderResolverService implements Resolve<OrderModel> {
  constructor(private dataService: DataService, private mathService: MathService, private orderService:OrderService, private paymentService:PaymentService, private utils:UtilsService) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<OrderModel> {
    const id = route.paramMap.get("orderId");
    // console.log(route.queryParamMap, route.queryParams);
    const basketId = route.queryParamMap.get("basketKey");
    const paymentStatus = route.queryParamMap.get("paymentStatus");
    const paymentId = route.queryParamMap.get("paymentKey");
    const context = await this.utils.getAppInfo();
    const profileId = route.paramMap.get("profileId");
    if ((id == "new" || id == null || id == undefined) && !basketId) {
      const newItem = <OrderModel>{
        details: {
          currency: "EUR",
          format: "solo",
          dateOrdered: Date(),
          type: null
        },
        status: "new",
        producer: {},
        consumer: {
          key: profileId
        },
        route: {
          geocoding: {}
        },
        tournee: null,
        tournees: null,
        products: {
          freeText: "",
          references: {}
        },
        messages: {},
        finances: {
          paymentMode: {},
          productCount: 0,
          orderCount: 0,
          totals: {
            sold: 0,
            paid: 0
          }
        },
        tech:context
      };
      return newItem;
    } 
    else if(basketId){
      // console.log('basket id',basketId);
      return this.paymentService.validatePayment(basketId,paymentId);
    }
    else {
      const item = await firstValueFrom(this.dataService.getOrder(id, profileId))
          if (item) {
            this.orderService.convertOrderToDatePlaceSystem(item);
            console.log(item);
            return item;
          } else {
            return ;
          }
    }
  }
}
